<div class="flex flex-col justify-center items-center text-2xl md:text-3xl font-semibold text-white space-y-8 mt-24">
    <span>
        A beküldés sikeres volt. A feldolgozást követően rövidesen megküldjük emailben az árajánlatot!
    </span>
    <span class="pt-16 text-xl md:text-2xl" >
        Köszönjük szépen az érdeklődést.
    </span>
</div>